export default "__VITE_ASSET__BLmEZySK__"